
import { createLogic } from "redux-logic";
import { GET_ACCOUNT } from "../types";

const getAccountDataLogic = createLogic({
	type: GET_ACCOUNT,
	latest: true,
	async process({ getState, action }, dispatch, done) {
		//TODO get account data
		done()
	},
});

export default [getAccountDataLogic];
